import { At, zodRefinement } from "../generated/dbs-rules"
import { countryCodeMapping } from "../utils/option-data"

/** The country list label for a code, for the county-not-country rule (DBS-322) */
export const countryLabelFor = (countryCode: string): string | undefined =>
  (countryCodeMapping as Record<string, { label: string }>)[countryCode]?.label

/**
 * The consolidated DBS rule set (DBS-344) as a zod refinement for an applicant form: `at` is the page being saved,
 * or 'confirm' for the confirm & complete screen, which runs every page's rules plus the cross-page ones.
 */
export const applicationRefinement = (at: At) => zodRefinement({ at, countryLabelFor })
